import { render, staticRenderFns } from "./user_dp_pj.vue?vue&type=template&id=8c0db5f2&scoped=true"
import script from "./user_dp_pj.vue?vue&type=script&lang=js"
export * from "./user_dp_pj.vue?vue&type=script&lang=js"
import style0 from "./user_dp_pj.vue?vue&type=style&index=0&id=8c0db5f2&prod&scoped=true&lang=less"
import style1 from "./user_dp_pj.vue?vue&type=style&index=1&id=8c0db5f2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0db5f2",
  null
  
)

export default component.exports